(function () {
  angular
    .module("app")
    .controller("replaceUserController", ["$http", "$uibModalInstance", "$q", "alkModalService", "oldUser", "isReplacingCurrent",
      function ($http, $uibModalInstance, $q, alkModalService, oldUser, isReplacingCurrent) {
        var vm = this;

        vm.oldUser = oldUser;
        vm.newUser = {};

        function getVm() {
          return {
            OldUserEmail: vm.oldUser.UserName,
            FirstName: vm.newUser.firstName,
            LastName: vm.newUser.lastName,
            Email: vm.newUser.email
          };
        }

        function replaceUser() {
          return $http.post("/api/ManageAccount/ReplaceUser", getVm());
        }

        function showWarningIfNeeded() {
          if (isReplacingCurrent) {
            return alkModalService.show({
              size: "sm"
            }, {
              headerText: "Replace yourself?",
              bodyText: "Are you sure you want to replace yourself?",
              closeButtonText: "Cancel",
              actionButtonText: "Replace myself",
            });
          } else {
            return $q.when();
          }
        }

        vm.replaceUser = function () {
          vm.isProcessing = true;
          vm.showGenericError = false;

          showWarningIfNeeded()
            .then(replaceUser)
            .then(function () {
              $uibModalInstance.close();
            })
            .catch(function (err) {
              if (err !== "cancel") {
                vm.showGenericError = true;
                return $q.reject(err);
              }
            })
            .finally(function () {
              vm.isProcessing = false;
            });
        };

        vm.close = function () {
          $uibModalInstance.dismiss("cancel");
        };
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/account/replaceUser.controller.js